import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createSop = createAsyncThunk("createSop", async ({ data }, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem("auth_token");

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};
		const response = await axiosHttp.post(`sop/create`, data, config);
		message.success("Your SOP has been created successfully!");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const SopCreateSlice = createSlice({
	name: "SopCreateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createSop.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createSop.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createSop.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateState } = SopCreateSlice.actions;
export default SopCreateSlice.reducer;
